import { Typography } from '@mui/material';
import * as Preact from 'preact';

export interface Props {
    originalPrice: number;
}

export const Component = (p: Props) => (
    <Typography fontWeight={400} fontSize="11px" height="18px" color="rgba(197, 11, 74, 1)">
        was{' '}
        <s>
            {Intl.NumberFormat('en-GB', {
                style: 'currency',
                currency: 'GBP',
            }).format(p.originalPrice)}
        </s>
    </Typography>
);

Component.displayName = 'OriginalPrice';
